<div
  v-if="shouldRenderConfig"
  v-show="getMatrixComplete"
  v-bind:class="getClassName"
>
  <button type="button" class="btn btn-primary" v-on:click="onClickBack()">
    {{ $t('Back to configuration') }}
  </button>
</div>
